module.exports = __webpack_public_path__ + "img/photo-26.f90fe957.jpg";